/**
 * @type {String}
 */
export const lcTextCardFragment = `... on ComponentLearningCenterTextCard {
  title
  content {
    json
  }
}`;
